import {
    Box, Center, Flex,
    FormLabel, Heading,
    Image, Stack
} from '@chakra-ui/react';
import HandWave from '../../../assets/icons/image.png';
import InputField from '../InputField';
import { FormStep } from '../MultiStepForm';

export default function Welcome(props: {user: any, onSubmit: any, validationSchema: any}) {
  const {user, onSubmit, validationSchema} = props; 

  return (<FormStep
    stepName="Welcome"
    validationSchema={validationSchema}
    buttonWidth="350px"
    onSubmit={onSubmit}
  >
    <Center>
        <Box w="350px">
            <Stack align="center" mb="6">
                <Image
                    src={HandWave}
                    alt="hand wave"
                    width="70px"
                    height="auto"
                    mb="24px"
                />
                <Heading
                    lineHeight="36px"
                    fontSize="32px"
                    letterSpacing="-0.02em"
                    fontWeight="800"
                    width="330px"
                    textAlign="center"
                >
                    Welcome! <br />
                    What's your name?
                </Heading>
            </Stack>
            <Stack
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                gap="6px"
            >
                <Flex>
                    <Stack>
                        <FormLabel
                            textAlign="left"
                            mb="-2"
                            fontWeight={600}
                            fontSize="15"
                        >
                            First Name
                        </FormLabel>
                        <InputField name="firstName" align="left" />
                    </Stack>
                    <Stack>
                        <FormLabel
                            textAlign="left"
                            mb="-2"
                            fontWeight={600}
                            fontSize="15"
                        >
                            Last Name
                        </FormLabel>
                        <InputField name="lastName" align="right" />
                    </Stack>
                </Flex>
                <Stack>
                    <FormLabel
                        textAlign="left"
                        mb="-2"
                        fontWeight={600}
                        fontSize="15"
                    >
                        Email Address
                    </FormLabel>
                    <InputField
                        name="email"
                        align="center"
                        width="350px"
                        disabled={user?.email !== ''}
                    />
                </Stack>

                <Stack>
                    <FormLabel
                        textAlign="left"
                        mb="-2"
                        fontWeight={600}
                        fontSize="15"
                    >
                        Phone Number
                    </FormLabel>
                    <InputField
                        name="phone"
                        align="center"
                        width="350px"
                        placeholder="1234567890"
                    />
                </Stack>
            </Stack>
        </Box>
    </Center>
  </FormStep>);
}